function preparePlugins(container) {
    container.find(".drop-down-wrap").each(function () {
        $(this).optimusDropDown();
    });
}

$(document).ready(function () {

    preparePlugins($(document));

    /*
    let options={
        theme:"default",
        position:"bottom",
        distance:20,
        borderRadius:4,
        background:"#00c0f3",
        backgroundOpacity:"1",
        fontSize:14,
        text:"Tyto webové stránky používají k poskytování svých služeb soubory Cookies. Používáním těchto webových stránek souhlasíte s použitím souborů Cookies.",
        html:false,
        textColor:"#000",
        showButton:true,
        buttonText:"SOUHLASÍM!",
        buttonColor:"#000",
        buttonBgColor:"#00c0f3",
        moreButtonText:"Více informací o Cookies",
        moreButtonColor:"#000",
        moreButtonLink:"https://www.cookie-lista.cz/co-je-cookies.html",
        showCloseButton:false,
        cookieDays:365
    };

    $("body").BeeCookie(options);

    $("#move-to-top").moveTop();

    */

    $(document).on('click', '.navbar .hamburger', function (e) {

        let target = $(this).data("target");

        console.log(target);

        if (isDefined(target)) {
            target = $(document).find(target);

            if (target.hasClass('visible')) {
                target.removeClass('visible');
            } else {
                target.addClass('visible');
            }

        }

    });

    $(document).on("click", "#login-customer-btn", function (e1) {
        let butt = $(this);
        if (butt.hasClass('disabled')) {
            return;
        }
        butt.addClass("disabled");
        butt.find(".fa-show-on-hover").hide();
        butt.find(".fa-spinner").show();

        let form = $(this).closest('form');

        form.submit(function (e2) {

            let formData = new FormData(this);
            e1.preventDefault();
            e2.preventDefault();

            let formUrl = form.attr("action");

            grecaptcha.ready(function () {
                grecaptcha.execute('6LcmncsZAAAAAOLnd9EYHsHSIaI6ZYMt-BtzVTau', {action: 'login'}).then(function (token) {
                    formData.append('token', token);
                    formData.append('action', 'login');
                    $.nette.ajax({
                        url: formUrl,
                        data: formData,
                        type: 'POST',
                        processData: false,
                        contentType: false,
                        off: {
                            snippets: true
                        }
                    }).done(function (payload) {
                        if (payload.error) {
                            toastr.warning(payload.error);
                        }
                        butt.find(".fa-spinner").hide();
                        butt.find(".fa-show-on-hover").show();
                        butt.removeClass('disable');
                    });
                });
            });


        });


    });

    $(document).on("click", "#register-customer-btn", function (e1) {
        let butt = $(this);
        if (butt.hasClass('disabled')) {
            return;
        }
        butt.addClass("disabled");
        butt.find(".fa-show-on-hover").hide();
        butt.find(".fa-spinner").show();

        let form = $(this).closest('form');

        form.submit(function (e2) {

            let formData = new FormData(this);
            e1.preventDefault();
            e2.preventDefault();

            let formUrl = form.attr("action");

            grecaptcha.ready(function () {
                grecaptcha.execute('6LcmncsZAAAAAOLnd9EYHsHSIaI6ZYMt-BtzVTau', {action: 'login'}).then(function (token) {
                    formData.append('token', token);
                    formData.append('action', 'login');
                    $.nette.ajax({
                        url: formUrl,
                        data: formData,
                        type: 'POST',
                        processData: false,
                        contentType: false,
                        off: {
                            snippets: true
                        }
                    }).done(function (payload) {
                        if (payload.error) {
                            toastr.warning(payload.error);
                        }
                        butt.find(".fa-spinner").hide();
                        butt.find(".fa-show-on-hover").show();
                        butt.removeClass('disable');
                    });
                });
            });


        });


    });

});